var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { emailApi } from "apis/eduidEmail";
import { ConfirmModal } from "components/Common/ConfirmModal";
import { CustomInput } from "components/Common/CustomInput";
import { EduIDButton } from "components/Common/EduIDButton";
import { useAppSelector } from "eduid-hooks";
import { useState } from "react";
import { Field as FinalField, Form as FinalForm } from "react-final-form";
import { FormattedMessage, useIntl } from "react-intl";
import { shortCodePattern } from "../../helperFunctions/validation/regexPatterns";
import { validateEmailField } from "../../helperFunctions/validation/validateEmail";
import { DataTable } from "./DataTable";
export function Emails() {
    const [showEmailForm, setShowEmailForm] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState();
    const emails = useAppSelector((state) => state.emails);
    const [verifyEmail] = emailApi.useLazyVerifyEmailQuery();
    const [resendEmailCode] = emailApi.useLazyResendEmailCodeQuery();
    const [newEmail] = emailApi.useLazyNewEmailQuery();
    const intl = useIntl();
    // placeholder can't be an Element, we need to get the actual translated string here
    const placeholder = intl.formatMessage({
        id: "emails.emailPlaceholder",
        defaultMessage: "name@example.com",
        description: "placeholder text for email input",
    });
    const modalPlaceholder = intl.formatMessage({
        id: "common.enterCodePlaceholder",
        defaultMessage: "enter code",
        description: "Placeholder for email code input",
    });
    function handleAdd(values) {
        return __awaiter(this, void 0, void 0, function* () {
            if (values.email) {
                const response = yield newEmail({ email: values.email });
                if (response.isSuccess) {
                    // email form closed when user have successfully added an email
                    return setShowEmailForm(false);
                }
            }
            else
                setShowEmailForm(true);
        });
    }
    function handleCancel() {
        setShowEmailForm(false);
    }
    function handleEmailForm() {
        setShowEmailForm(true);
    }
    function handleResend(event) {
        event.preventDefault();
        if (selectedEmail)
            resendEmailCode({ email: selectedEmail });
    }
    function handleStopConfirmation() {
        setSelectedEmail(undefined);
    }
    function handleConfirm(values) {
        const confirmationCode = values["email-confirm-modal"];
        if (confirmationCode && selectedEmail)
            verifyEmail({ code: confirmationCode.trim(), email: selectedEmail });
        setSelectedEmail(undefined);
    }
    function validateEmailsInForm(value) {
        if (!value) {
            return "required";
        }
        /* Check if the value (new email-address) is already present in the list of the users' e-mail addresses */
        const is_duplicate = emails.emails.find((x) => x.email === value);
        if (is_duplicate) {
            return "emails.duplicated";
        }
        return validateEmailField(value);
    }
    return (_jsxs("article", { id: "add-email-addresses", children: [_jsx("h2", { children: _jsx(FormattedMessage, { id: "emails.title", defaultMessage: "Email addresses", description: "Emails main title" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "emails.description", defaultMessage: `You can connect one or more email addresses with your eduID account and select one to be
            your primary email address.`, description: "Add emails description" }) }), _jsxs("div", { className: "email-display", children: [_jsx(DataTable, { data: emails.emails, setSelectedEmail: setSelectedEmail }), showEmailForm ? (_jsx(FinalForm, { onSubmit: handleAdd, initialValues: {
                            email: "",
                        }, render: ({ handleSubmit, pristine, invalid }) => {
                            return (_jsxs("form", { onSubmit: handleSubmit, children: [_jsx(FinalField, { label: _jsx(FormattedMessage, { id: "common.emailAddress", defaultMessage: "Email address", description: "profile email display title" }), component: CustomInput, componentClass: "input", type: "text", name: "email", placeholder: placeholder, validate: validateEmailsInForm, autoFocus: true }), _jsxs("div", { className: "buttons", children: [_jsx(EduIDButton, { id: "cancel-adding-email", buttonstyle: "secondary", onClick: handleCancel, children: _jsx(FormattedMessage, { id: "common.cancel", defaultMessage: "Cancel", description: "button cancel" }) }), _jsx(EduIDButton, { type: "submit", id: "add-email", buttonstyle: "primary", disabled: invalid || pristine, onClick: handleSubmit, children: _jsx(FormattedMessage, { id: "common.add", defaultMessage: "Add", description: "Emails button add" }) })] })] }));
                        } })) : (_jsx(EduIDButton, { id: "emails-add-more-button", buttonstyle: "link normal-case", onClick: handleEmailForm, children: _jsx(FormattedMessage, { id: "emails.addButton", defaultMessage: "+ Add more", description: "button add more" }) }))] }), _jsx(ConfirmModal, { id: "email-confirm-modal", title: _jsx(FormattedMessage, { id: "emails.emailTitle", defaultMessage: `Enter the code sent to {email}`, description: "Title for email code input", values: { email: selectedEmail } }), placeholder: modalPlaceholder, showModal: Boolean(selectedEmail), closeModal: handleStopConfirmation, handleConfirm: handleConfirm, modalFormLabel: _jsx(FormattedMessage, { id: "common.code", description: "emails enter code", defaultMessage: `Code` }), validationError: "confirmation.code_invalid_format", validationPattern: shortCodePattern, resendMarkup: _jsx("div", { className: "resend-code-container", children: _jsx(EduIDButton, { buttonstyle: "link normal-case", onClick: handleResend, children: _jsx(FormattedMessage, { id: "emails.resend", description: "resend code", defaultMessage: `Send a new code` }) }) }) })] }));
}
